<template>
  <layout-content title="title">
    <div :class="`${need_show_tutorial ? 'overlay-blur' : ''}`"></div>
    <z-form ref="form" :class="`${need_show_tutorial ? 'w-50 tutorial-form' : 'w-50'}`">
      <div class="z-card">
        <h2>{{ $t('autoinformer.campaign.form.recipients_title') }}</h2>
        <div
          :class="`${tutorial_steps[counter].id === 'create' ? `hint hint--recipients` : ''}`"
          :title="tutorial_steps[counter].text"
        >
          <input-recipient
            v-model="recipients"
            :is_hint="tutorial_steps[counter].id === 'create'"
          />
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <div
            :class="`${tutorial_steps[counter].id === 'ok' ? `hint hint--save` : ''}`"
            :title="tutorial_steps[counter].text"
          >
            <i-button :loading="is_loading" type="primary" size="large" @click="send">
              {{ $t('autoinformer.campaign.form.save_btn') }}
            </i-button>
          </div>
        </div>
      </div>
      <div
        v-if="need_show_tutorial"
        class="tutorial-navigation-wrap tutorial-navigation-wrap--close"
        @click="close_tutorial"
      ></div>
      <div
        v-if="need_show_tutorial"
        class="tutorial-navigation-wrap tutorial-navigation-wrap--pagination"
      >
        <div v-if="counter !== 0" class="arrow--back" @click="backward_tutorial"></div>
        {{ counter + 1 }} / {{ tutorial_steps.length }}
        <div
          v-if="counter + 1 < tutorial_steps.length"
          class="arrow"
          @click="forward_tutorial"
        ></div>
      </div>
    </z-form>
  </layout-content>
</template>

<script>
  import { TaskService } from '@autoinformer/services/TaskService';
  import InputRecipient from '@autoinformer/components/campaigns-input-recipient';

  export default {
    components: {
      InputRecipient
    },
    data() {
      return {
        need_show_tutorial: false,
        counter: 0,
        tutorial_steps: [
          {
            id: 'create',
            text: 'Добавьте номера по одному или загрузите базу номеров для прозвона'
          },
          {
            id: 'ok',
            text: 'Нажмите “Сохранить”'
          }
        ],
        is_loading: false,
        recipients: {
          recipients: [],
          include: [],
          exclude: []
        }
      };
    },
    created() {
      this.need_show_tutorial = !!this.$route.params?.tutorial;
    },
    computed: {
      get_numbers_field() {
        const db = this.recipients;
        const include = db.include.map((i) => this.format_db_fields(i));
        const exclude = db.exclude.map((i) => this.format_db_fields(i));
        const recipients = db.recipients.map((i) => i);
        return {
          include,
          exclude,
          recipients
        };
      }
    },

    methods: {
      close_tutorial() {
        this.need_show_tutorial = false;
        this.counter = 0;
      },
      backward_tutorial() {
        this.counter -= 1;
      },
      forward_tutorial() {
        if (this.counter < this.tutorial_steps.length) {
          this.counter += 1;
        }
      },
      send() {
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            const numbers = this.get_numbers_field;
            const { include, exclude, recipients } = numbers;

            if (include.length > 0 || exclude.length > 0 || recipients.length > 0) {
              this.is_loading = true;

              const campaign_id = this.$route.params.id;
              TaskService.createItem(campaign_id, numbers)
                .then(() => {
                  this.$router.push({
                    name: 'autoinformer.campaign.tasks',
                    params: { tutorial: this.need_show_tutorial, counter: 1 }
                  });
                })
                .catch((error) => {
                  this.$noty.server_error(error);
                })
                .finally(() => {
                  this.is_loading = false;
                });
            }
          }
        });
      },
      format_db_fields(db) {
        return db.id;
      }
    }
  };
</script>

<style lang="scss">
  .tutorial-form {
    .hint--recipients {
      &:before {
        right: -75px;
        top: 85%;
      }

      &:after {
        top: 100%;
        width: 180px;
      }
    }

    .hint--save {
      z-index: 100;

      &:before {
        top: 35%;
        left: 127px;
      }
      &:after {
        left: 150px;
        top: 80%;
      }
    }
  }
</style>
